import React from 'react';
import NormalBtn from './StockItems/NormalBtn';

function App(props){

	var clickBack = props.clickBack;

	return <center>This Screen has been deleted by one of your collaborators<br/><br/><NormalBtn onClick={clickBack} title="Back"/></center>
        
}

export default App;


